<!-- Begin Page Content -->
<div class="container-fluid">

    <!-- DataTales Example -->
    <div class="card shadow mb-4">
        <div class="card-header d-sm-flex align-items-center justify-content-between py-3">
            <h1 class="h3 mb-0 text-gray-800">Users</h1>
            <!-- download xls -->
            <button (click)="downloadUsers()" [disabled]="isLoadingUsersExport" class="d-none d-sm-inline-block btn btn-sm btn-success shadow-sm">
                <span *ngIf="isLoadingUsersExport" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                {{ isLoadingUsersExport ? 'Loading...' : 'Export To Excel' }}
            </button>
        </div>
        
        <div class="card-body">
            <div class="table-responsive">
                <table datatable [dtOptions]="dtOptions" class="table table-bordered hover" width="100%"
                    cellspacing="0">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Username</th>
                            <th>Phone Number</th>
                            <th>Email</th>
                            <th>Subscription</th>
                            <th>Venue Package Choosen</th>
                            <th>Venue Subscription Expiry</th>
                            <th>User Status</th>
                            <th>Action</th>

                        </tr>
                    </thead>
                    <tbody *ngIf="users?.length != 0">
                        <tr *ngFor="let user of users">
                            <td class="name">{{ (user.name !== '') ? user.name : 'N/A' }}</td>
                            <td class="username">{{ (user.username !== '') ? user.username : 'N/A'
                                }} </td>
                            <td class="phone_number">{{ (user.phone_number !== '') ? user.phone_number : 'N/A'
                                }} </td>
                            <td class="email">{{ (user.email !== '') ? user.email : 'N/A' }}</td>
                            <td>{{ (user.subscription_detail?.status) ? user.subscription_detail.status : 'N/A'
                                }}</td>
                            <td class="package">{{ (user.venue_subscription_detail?.name) ?
                                user.venue_subscription_detail.name : 'N/A' }}</td>
                            <td class="subscription_expiry">{{ (user?.venue_subscription_expiration) ?
                                (user.venue_subscription_expiration | date) :
                                'N/A' }} </td>
                            <td>{{user.status}}</td>
                            <td style="width: 15%;">
                                <a routerLink="/user/{{ user._id }}" class="btn btn-primary btn-sm">View</a>
                            </td>
                        </tr>
                    </tbody>
                    <tbody *ngIf="users?.length == 0">
                        <tr>
                            <td colspan="3" class="no-data-available">No records found!</td>
                        </tr>
                    <tbody>
                </table>
            </div>
        </div>
    </div>

</div>
<!-- /.container-fluid -->